const barcode = '853149008105';

const state = () =>
({
  barcode
});

const mutation = key => (state, value) =>
{
  state[key] = value;
};

const barcode_update = mutation('barcode');

export default
{
  state,
  mutations:
  {
    barcode_update
  },
};